import { render } from "./search-type.vue?vue&type=template&id=f47d6d76&scoped=true"
import script from "./search-type.vue?vue&type=script&lang=js"
export * from "./search-type.vue?vue&type=script&lang=js"

import "./search-type.vue?vue&type=style&index=0&id=f47d6d76&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f47d6d76"]])

export default __exports__